/* global axios */
import ApiClient from './ApiClient';

class ToolsAPI extends ApiClient {
  constructor() {
    super('llm_tools', { accountScoped: true });
  }

  createTool(payloadBody) {
    return axios.post(`${this.url}`, payloadBody);
  }

  // get item
  getToolSearch(params={}) {
    return axios.get(`${this.url}/lists`,{
      params: {
        ...params
      }
    });
  }
  getToolList(params={}) {
    return axios.get(`${this.url}/globals`,{
      params: {
        ...params
      }
    });
  }
  getToolsFilterList(params={}) {
    const {payload,...restParams} = params;
    return axios.post(`${this.url}/filter`,{payload},{
      params: {
        ...restParams
      }
    });
  }

  fetchToolById(tool_id,) {
    return axios.get(`${this.url}/${tool_id}`,);
  }

  updateToolById(tool_id,payload) {
    return axios.patch(`${this.url}/${tool_id}`,payload);
  }
  deleteToolById(tool_id,) {
    return axios.delete(`${this.url}/${tool_id}`,);
  }

}

export default new ToolsAPI();
